import React from 'react'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'
import Input from "Components/Input";


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
    constructor (props) {
        super(props)

        const newState = {
            ...props,
            action: props.action,
            key: Utils.getRandomNumber(),
        }
        this.state = {
            saveState: { ...EurestoClone(newState)},
            ...newState
        }
    }

    componentDidMount () {
        if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
            this.getFormation()
        }
    }

    getFormation = async () => {
        const result = await ApiRequest(project.api + 'pedagogie', {
            requete: 'formation',
            action: 'get',
            id: this.state.id
        }, { showAlertError: false })
        if(result && result.code === 1) {
            const newState = {
                defaultLibelle: result.results.libelle,
                libelle: result.results.libelle,
                abrege: result.results.abrege,
                actif: result.results.actif,
                descriptif: result.results.descriptif,
                key: Utils.getRandomNumber()
            }
            this.setState({
                saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
                ...newState,
                key: Utils.getRandomNumber()
            }, this.forceUpdate)
        }
    }

    onChangeState = (e, name) => {
        this.setState({
            [name]: e
        }, this.forceUpdate)
    }

    onCancel = _ => {
        this.setState({
            libelle: undefined,
            abrege: '',
            action: 'add',
            descriptif: '',
            key: Utils.getRandomNumber()
        }, () => this.props.onCancel())
    }

    onSave = async (action) => {
        const result = await ApiRequest(project.api + 'pedagogie', {
            requete: 'formation',
            action: action === 'update' ? 'update' : 'add',
            id: this.state.id,
            libelle: this.state.libelle,
            abrege: this.state.abrege,
            descriptif: this.state.descriptif,
        })
        if (result.code === 1) {
            this.onCancel()
        }
    }

    onDelete = async () => {
        const r = await ApiRequest(project.api + 'pedagogie', {
            requete: 'formation',
            action: 'delete',
            id: this.state.id,
        })
        if (r && r.code === 1) {
            this.setState({
                action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
            })
        }
    }

    onArchive = async () => {
        console.log('not done yet')
    }

    onView = (action) => {
        const newState = this.state.saveState
        newState.saveState = {...EurestoClone(this.state.saveState)}
        newState.key = Utils.getRandomNumber();
        const keys = Object.keys(this.state)
        const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
        this.setState({
            ...stateReset,
            ...newState
        }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
    }

    form = (disabled, autoFocus) => {
        return (
            <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
                  justify="flex-start"
                  alignItems="stretch">
                <Input
                    key={autoFocus}
                    autoFocus={autoFocus}
                    title={EurestoI18n.t('commun:Nom')}
                    onChange={this.onChangeState}
                    name={'libelle'}
                    disabled={disabled}
                    value={this.state.libelle}
                />
                <Input
                    title={EurestoI18n.t('commun:Abrégé')}
                    onChange={this.onChangeState}
                    name={'abrege'}
                    disabled={disabled}
                    value={this.state.abrege}
                />
                <Input
                    title={EurestoI18n.t('commun:Descriptif')}
                    onChange={this.onChangeState}
                    name={'descriptif'}
                    disabled={disabled}
                    value={this.state.descriptif}
                />
            </Grid>
        )
    }

    render () {
        return (
            <EurestoForm key={this.state.key}
                         {...this.props.formProps}
                         libelle={this.state.defaultLibelle}
                         action={this.state.action}
                         isAllow={this.props.isAllow}
                         onSave={this.onSave}
                         onCancel={this.onCancel}
                         onDelete={this.onDelete}
                         onArchive={this.onArchive}
                         onView={this.onView}
                         libelleAdd={EurestoI18n.t('commun:Nouvelle formation')}
                         children={this.form}/>
        )
    }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Pedagogie/Formation.js